import api from '../utils/helpers/bootstrapApi';

const axiosFetchBase = async ({
  url,
  method = 'GET',
  data = null,
  params,
  ...config
}) => {
  try {
    const result = await api({ url, method, data, params, ...config });
    if (config && config.responseType === 'blob') {
      return { data: { blob: result.data, headers: result.headers } };
    }
    return { data: result.data };
  } catch (err) {
    return {
      error: {
        status: err.response?.status,
        data: err.response?.data || err.message,
      },
    };
  }
};

export default axiosFetchBase;
